/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Math.Easing.Stepped

module.exports = require('./Stepped');



//////////////////
// WEBPACK FOOTER
// ./math/easing/stepped/index.js
// module id = 299
// module chunks = 0